export default "__VITE_ASSET__C5DE1oxY__"